!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.gridItems = this.querySelectorAll("[data-grid-item]");
    }
    connectedCallback() {
      this.setItemHeight(), this.boundResizeHandler = this.handleResize.bind(this), window.addEventListener("resize", this.boundResizeHandler);
    }
    disconnectedCallback() {
      this.boundResizeHandler && window.removeEventListener("resize", this.boundResizeHandler);
    }
    handleResize() {
      this.setItemHeight();
    }
    setItemHeight() {
      const e = this.gridItems[0];
      if (!e) return;
      const t = e.querySelector("img, video");
      if (!t) return;
      const i = t.offsetHeight;
      this.style.setProperty("--grid-item-height", `${i}px`);
    }
  }
  customElements.get("product-grid") || customElements.define("product-grid", e);
}();